import { Controller } from "stimulus"
import $ from "jquery"
// CSS is imported in application.js pack for better production compatibility
import "summernote/dist/summernote-lite.js"

export default class extends Controller {
  connect() {
    console.log('Summernote controller connected')

    // Find the textarea using querySelector instead of targets
    const editorElement = this.element.querySelector('[data-summernote-target="editor"]')

    if (!editorElement) {
      console.error('Summernote editor element not found')
      return
    }

    // Store reference
    this.editorElement = editorElement

    // Expose controller instance on the element for external access
    this.element.summernoteController = this

    // Initialize Summernote on the textarea
    $(editorElement).summernote({
      height: 400,
      minHeight: 300,
      maxHeight: 600,
      placeholder: editorElement.dataset.placeholder || 'Compose your email...',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
        ['table', ['table']],
        ['insert', ['link', 'picture']],
        ['view', ['fullscreen', 'codeview', 'help']]
      ],
      styleTags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      fontNames: ['ui-sans-serif'],
      fontNamesIgnoreCheck: ['Arial', 'Helvetica', 'Verdana'],
      callbacks: {
        onChange: (contents) => {
          // Update the textarea value when content changes
          $(editorElement).val(contents)
        }
      }
    })

    console.log('Summernote initialized successfully')
  }

  // Method to set content programmatically (for AI improvements)
  setContent(html) {
    if (this.editorElement) {
      $(this.editorElement).summernote('code', html)
    }
  }

  // Method to get content
  getContent() {
    if (this.editorElement) {
      return $(this.editorElement).summernote('code')
    }
    return ''
  }

  disconnect() {
    if (this.editorElement && $(this.editorElement).data('summernote')) {
      $(this.editorElement).summernote('destroy')
    }
  }
}
